// import React, { useState, useEffect } from "react";
// import { Grid, TextField, Divider } from "@mui/material";
// import axios from "axios";


// const DetailTemplateComponent = ({ data }) => {
//   const [workInfo, setWorkInfo] = useState([]);
//   const [loading, setLoading] = useState(true);




// const getFilteredData = async (workTypeIDs) => {
//   if (!workTypeIDs || workTypeIDs.length === 0) {
//     console.warn("No workTypeIDs provided.");
//     return [];
//   }

//   const workTypeIDsString = workTypeIDs.map(id => `'${id}'`).join(",");

//   const apiEndpoints = [
//     { name: "permits", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
//     { name: "electrical", url: `https://data.cityofnewyork.us/resource/dm9a-ab7w.json?$where=job_number in(${workTypeIDsString})&$limit=50000` },
//     { name: "dobJobs", url: `https://data.cityofnewyork.us/resource/rvhx-8trz.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
//     { name: "applicationFilings", url: `https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
//     { name: "permitIssuance", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
//   ];

//   const dynamicEndpoints = [
//     {
//       name: "dobNowJobs",
//       baseUrl: "https://data.cityofnewyork.us/resource/w9ak-ipjd.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
//     },
//     {
//       name: "approvedPermits",
//       baseUrl: "https://data.cityofnewyork.us/resource/rbx6-tga4.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
//     }
//   ];

//   try {
//     const staticApiCalls = apiEndpoints.map(endpoint =>
//       axios.get(endpoint.url)
//         .then(res => res.data)
//         .catch(err => {
//           console.error(`Error fetching ${endpoint.name}`, err);
//           return [];
//         })
//     );

//     const dynamicApiCalls = dynamicEndpoints.flatMap(endpoint =>
//       workTypeIDs.map(id =>
//         axios.get(endpoint.baseUrl.replace('{id}', id))
//           .then(res => res.data)
//           .catch(err => {
//             console.error(`Error fetching ${endpoint.name} for ${id}`, err);
//             return [];
//           })
//       )
//     );

//     const results = await Promise.all([...staticApiCalls, ...dynamicApiCalls]);

//     const extractFields = (data) =>
//       data.map(item => ({
//         approvalDate: item.approved_date || null,
//         permitNumber: item.work_permit || null,
//         permitIssued: item.issued_date || null,
//         permitExpires: item.expired_date || null,
//         signOffDate: item.sign_off_date || item.signoff_date || null,
//         locDate: item.c_o_issue_date || null,
//       }));

//     const allData = results.flatMap(extractFields);
//     return allData;
//   } catch (error) {
//     console.error("Error fetching work types data:", error);
//     return [];
//   }
// };


















//   useEffect(() => {
//     const fetchDetails = async () => {
//       setLoading(true);
//       const jobNumber = data?.dobNumber || data?.job_number || data?.id;
//       const result = await getFilteredData([jobNumber]);
//       setWorkInfo(result);
//       setLoading(false);
//     };

//     fetchDetails();
//   }, [data]);

//   return (
//     <div style={{ padding: '10px', background: '#f8f8f8', minHeight: '200px' }}>
//       {loading ? (
//         <p>Loading work type info...</p>
//       ) : workInfo.length === 0 ? (
//         <p>No work type info available.</p>
//       ) : (
//         <Grid container spacing={2}>
//           {workInfo.map((item, index) => (
//             <Grid item xs={12} key={index}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Approval Date"
//                     variant="outlined"
//                     type="date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={item.approvalDate ? item.approvalDate.split("T")[0] : ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Permit Number"
//                     variant="outlined"
//                     fullWidth
//                     value={item.permitNumber || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Permit Issued"
//                     variant="outlined"
//                     type="date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={item.permitIssued ? item.permitIssued.split("T")[0] : ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Permit Expires"
//                     variant="outlined"
//                     type="date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={item.permitExpires ? item.permitExpires.split("T")[0] : ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Sign-Off Date"
//                     variant="outlined"
//                     type="date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={item.signOffDate ? item.signOffDate.split("T")[0] : ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="LOC Date"
//                     variant="outlined"
//                     type="date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={item.locDate ? item.locDate.split("T")[0] : ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//               </Grid>
//               {index < workInfo.length - 1 && (
//                 <Divider sx={{ my: 2 }} />
//               )}
//             </Grid>
//           ))}
//         </Grid>
//       )}
//     </div>
//   );
// };

// export default DetailTemplateComponent;

























import React, { useState, useEffect } from "react";
import { Grid, TextField, Divider } from "@mui/material";
import axios from "axios";

const DetailTemplateComponent = ({ data }) => {
  const [workInfo, setWorkInfo] = useState([]);
  const [loading, setLoading] = useState(true);

  const getFilteredData = async (workTypeIDs) => {
    if (!workTypeIDs || workTypeIDs.length === 0) {
      console.warn("No workTypeIDs provided.");
      return [];
    }

    const workTypeIDsString = workTypeIDs.map(id => `'${id}'`).join(",");

    const apiEndpoints = [
      { name: "permits", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
      { name: "electrical", url: `https://data.cityofnewyork.us/resource/dm9a-ab7w.json?$where=job_number in(${workTypeIDsString})&$limit=50000` },
      { name: "dobJobs", url: `https://data.cityofnewyork.us/resource/rvhx-8trz.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
      { name: "applicationFilings", url: `https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
      { name: "permitIssuance", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
    ];

    const dynamicEndpoints = [
      { name: "dobNowJobs", baseUrl: "https://data.cityofnewyork.us/resource/w9ak-ipjd.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000" },
      { name: "approvedPermits", baseUrl: "https://data.cityofnewyork.us/resource/rbx6-tga4.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000" },
    ];

    try {
      const staticApiCalls = apiEndpoints.map(endpoint =>
        axios.get(endpoint.url)
          .then(res => res.data)
          .catch(err => {
            console.error(`Error fetching ${endpoint.name}`, err);
            return [];
          })
      );

      const dynamicApiCalls = dynamicEndpoints.flatMap(endpoint =>
        workTypeIDs.map(id =>
          axios.get(endpoint.baseUrl.replace('{id}', id))
            .then(res => res.data)
            .catch(err => {
              console.error(`Error fetching ${endpoint.name} for ${id}`, err);
              return [];
            })
        )
      );

      const results = await Promise.all([...staticApiCalls, ...dynamicApiCalls]);

      const extractFields = (data) =>
        data.map(item => ({
          permitNumber: item.work_permit || null,
          approvalDate: item.approved_date || null,
          permitIssued: item.issued_date || null,
          permitExpires: item.expired_date || null,
          signOffDate: item.signoff_date || null,
          locDate: item.current_status_date|| null,
          jobFilingNumber:item.job_filing_number || null,
          doc:item.doc__||null,
//          filingStatus:item.filing_status || null,
          applicantFirstName:item.applicant_s_first_name|| null,
          applicantLastName:item.applicant_s_last_name|| null,
          filingRepresentativeFirstName:item.filing_representative_first_name|| null,
          filingRepresentativeLastName:item.filing_representative_last_name|| null,
          filingRepresentativeBusinessName:item.filing_representative_business_name|| null,
        }));

      const allData = results.flatMap(extractFields);

   

   
    const uniqueData = Array.from(
     new Map(allData.map(item => [JSON.stringify(item), item])).values()
    );


      //return allData;
      return uniqueData;

    } catch (error) {
      console.error("Error fetching work types data:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      const jobNumber = data?.dobNumber || data?.job_number || data?.id;
      const result = await getFilteredData([jobNumber]);
      setWorkInfo(result);
      setLoading(false);
    };

    fetchDetails();
  }, [data]);


  const renderFields = (item) => {
    const fields = [
      { label: "Permit Number", value: item.permitNumber },
      { label: "Approval Date", value: item.approvalDate ? item.approvalDate.split("T")[0] : null },
      { label: "Permit Issued", value: item.permitIssued ? item.permitIssued.split("T")[0] : null },
      { label: "Permit Expires", value: item.permitExpires ? item.permitExpires.split("T")[0] : null },
      { label: "Sign-Off Date", value: item.signOffDate ? item.signOffDate.split("T")[0] : null },
      { label: "LOC Date", value: item.locDate ? item.locDate.split("T")[0] : null },
      { label: "Job Number", value: item.jobFilingNumber},
      { label: "Doc #", value: item.doc },
//      { label: "Filing Status", value: item.filingStatus },
      { label: "Applicant First Name", value: item.applicantFirstName },
      { label: "Applicant Last Name", value: item.applicantLastName },
      { label: "Filing Rep First Name", value: item.filingRepresentativeFirstName },
      { label: "Filing Rep Last Name", value: item.filingRepresentativeLastName },
      { label: "Filing Rep Business Name", value: item.filingRepresentativeBusinessName },

    ];

    // return fields
    //   .filter(field => field.value) // only show non-empty fields
    //   .map((field, idx) => (
    //     <Grid item xs={12} sm={6} md={3} key={idx}>
    //       <TextField
    //         label={field.label}
    //         variant="outlined"
    //         fullWidth
    //         value={field.value}
    //         InputProps={{ readOnly: true }}
    //       />
    //     </Grid>
    //   ));

    // return (
    //   <div style={{ overflowX: 'auto', padding: '16px' }}>
    //     <Grid container spacing={2} wrap="nowrap" sx={{ minWidth: 'max-content' }}>
    //       {fields
    //         .filter(field => field.value) 
    //         .map((field, idx) => (
    //           <Grid item key={idx} sx={{ minWidth: 250 }}>
    //             <TextField
    //               label={field.label}
    //               variant="outlined"
    //               fullWidth
    //               value={field.value}
    //               InputProps={{ readOnly: true }}
    //             />
    //           </Grid>
    //         ))}
    //     </Grid>
    //   </div>
    // );
    

    return (
      <div style={{padding: '16px' }}>
        <Grid container spacing={2} wrap="nowrap" sx={{ minWidth: 'max-content' }}>
          {fields
            .filter(field => field.value) 
            .map((field, idx) => (
              <Grid item key={idx} sx={{ minWidth: 250 }}>
                <TextField
                  label={field.label}
                  variant="outlined"
                  fullWidth
                  value={field.value}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    );
  };

  return (
    <div style={{ padding: '10px', background: '#f8f8f8', minHeight: '200px' }}>
      {loading ? (
        <p>Loading work type info...</p>
      ) : workInfo.length === 0 ? (
        <p>No work type info available.</p>
      ) : (
        <Grid container spacing={2} style={{ overflowX: 'auto'}}>
          {workInfo.map((item, index) => (
            <Grid item xs={12} key={index} >
              <Grid container spacing={2}>
                {renderFields(item)}
              </Grid>
              {index < workInfo.length - 1 && (
                <Divider sx={{ my: 2 }} />
              )}
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );


  
  


};

export default DetailTemplateComponent;
